var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-center" },
    [
      _c("v-progress-circular", {
        staticClass: "primary--text",
        attrs: {
          indeterminate: "",
          size: 100,
          "aria-label": _vm.$t("aria.loading"),
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }